import { useMemo } from 'react';

import { useMutation } from '@tanstack/react-query';
import Api from 'hooks/Api';
import { useAppWrapperContext } from 'ui/layouts/AppWrapper';
import { useAdmin } from 'utils/helpers';
import { useProvider } from 'utils/providers/Provider';
import { ApiError } from 'utils/types';

export default function useRegisterDevice() {
  const { isAdmin } = useAdmin();
  const {
    state: { isPreview },
  } = useAppWrapperContext();
  const { state } = useProvider();
  const args = state;

  const version = useMemo(() => {
    if (isAdmin && !isPreview) return 'v3';
    if (isAdmin && isPreview) return 'v2';
    return 'v1';
  }, [isAdmin, isPreview]);

  return useMutation<any, ApiError, string>({
    mutationFn: async (payload) => {
      const api = new Api(args);

      const data = await api.post({
        url: `api/${version}/notifications/devices/register`,
        payload: {
          token: payload,
        },
      });

      return data;
    },
  });
}
